import { render, staticRenderFns } from "./NewsPanel.vue?vue&type=template&id=ef2ad106&scoped=true"
import script from "./NewsPanel.vue?vue&type=script&lang=js"
export * from "./NewsPanel.vue?vue&type=script&lang=js"
import style0 from "./NewsPanel.vue?vue&type=style&index=0&id=ef2ad106&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2ad106",
  null
  
)

export default component.exports